import { WorkerPolicyKey } from '@nxsys/constants/workerPolicy';

export const hasPolicy = (
  heldPolicies: string[],
  requiredPolicy: WorkerPolicyKey,
): boolean => {
  return heldPolicies.includes(requiredPolicy);
};

export const hasAllPolicies = (
  heldPolicies: string[],
  requiredPolicies: WorkerPolicyKey[],
): boolean => {
  return requiredPolicies.every((policy) => hasPolicy(heldPolicies, policy));
};

export const hasAnyPolicy = (
  heldPolicies: string[],
  requiredPolicies: WorkerPolicyKey[],
): boolean => {
  return requiredPolicies.some((policy) => hasPolicy(heldPolicies, policy));
};
